import type { Option } from "src/types/option";

export const createAvcOption = (name: string): Option<string> => {
  return {
    title: name,
    value: name,
  };
};
